import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const HearingAgreement = () => {
  const fileStatus = 10;
  const applicationPath = {
    copyright: "/admin/hearing-copyright",
    agreement: "/admin/hearing-agreement",
  };
  
  // Add route to details page
  const detailsRoute = "/admin/hearing-agreement-details";
  const pageTitle  = "শুনানীর চিঠি";

  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default HearingAgreement;
